import classNames from "classnames/bind";
import StockNumberSearch from "common/layout/Header/components/StockNumberSearch";
import { ResolvedStockNumberSearch } from "resolvers/base/stockNumberSearchResolver";
import styles from "./HeaderStockNumberSearch.module.scss";

const cx = classNames.bind(styles);

const HeaderStockNumberSearch = ({
    changeFocusStockInput,
    stockNumberSearch,
    onResize,
}: {
    changeFocusStockInput: (value: boolean) => void;
    stockNumberSearch: ResolvedStockNumberSearch;
    onResize: () => void;
}) => (
    <div className={cx("wrapper")}>
        <StockNumberSearch
            changeFocusStockInput={changeFocusStockInput}
            onResize={onResize}
            {...stockNumberSearch}
        />
    </div>
);

export default HeaderStockNumberSearch;
